import { trackWebVital } from './services/analyticsService';

const reportWebVitals = (onPerfEntry) => {
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB, onINP }) => {
    const handleMetric = (metric) => {
      trackWebVital({
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id,
      });

      if (onPerfEntry && onPerfEntry instanceof Function) {
        onPerfEntry(metric);
      }
    };

    getCLS(handleMetric);
    getFID(handleMetric);
    getFCP(handleMetric);
    getLCP(handleMetric);
    getTTFB(handleMetric);
    if (typeof onINP === 'function') {
      onINP(handleMetric);
    }
  });
};

export default reportWebVitals;
